<template lang="pug">
  .cart-refill-cart-item.xs-12
    .xs-mb-70m.sm-mb-100m.prod-cell
      .prod-cell-left
        a(v-if="item.url_key" :href='productUrl' target="_self")
          img.prod-cell-object(:src="productImgUrl" :alt="imgAltText")
        img.prod-cell-object(v-if="!item.url_key" :src="productImgUrl" :alt="imgAltText")

      .row-0.prod-cell-body
        .sm-12.lg-9
          .row
            .xs-12.pr-10
              p.xs-f-small.max-at-tweak.normal {{ item.name }}
                span(v-if="item.qty > 1")  &times; {{ item.qty }}

            .xs-12.pr-10
              p.xs-f-small.max-at-tweak.light(v-if="item.subscription_id && !item.isAttachment") Frequency: every {{ item.subscription }} weeks
              p.xs-f-small.max-at-tweak.light(v-if="item.subscription_id && item.isAttachment") Subscription-Add-On Item
              p.xs-f-small.max-at-tweak.light(v-if="!item.subscription_id") Add-On Item

            .xs-12(v-if="!item.subscription_id")
              button.transparent-btn(@click="moveToActiveCart")
                span.xs-f-small.max-at-tweak.normal.color-mr-purple Move to bag
  
</template>

<script>
  import { mapActions } from "vuex";
  import {getObjProperty} from "../../../../utilities/mrVueUtils";
  export default {
    name: "CartRefillCartItem",

    inject: ['getObjProperty'],

    props: {
      item: {
        type: Object,
        required: true
      }
    },

    computed: {
      productUrl() {
        return `/product/${this.item.url_key}`;
      },

      productImgUrl() {
        return getObjProperty(this.item, 'imagery.thumb.url');
      },

      imgAltText() {
        return `Madison Reed - ${this.item.name}`;
      }
    },

    methods: {
      ...mapActions('cart', ['moveToOtherCart']),

      moveToActiveCart() {
        let params = {
          from: 'refill',
          to: 'cart',
          index: this.item.index
        };

        this.moveToOtherCart(params);
      },
    }
  }
</script>

<style scoped lang="stylus">
  .cart-refill-cart-item
    padding 0.5em 0

    img
      width 3em

</style>